// src/components/TimezoneSelector.tsx
import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { TIMEZONES } from '../constants/timezone';

interface TimezoneSelectorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const TimezoneSelector: React.FC<TimezoneSelectorProps> = ({ value, onChange, disabled }) => (
  <FormControl fullWidth disabled={disabled}>
    <InputLabel>Timezone</InputLabel>
    <Select
      value={value}
      label="Timezone"
      onChange={(e) => onChange(e.target.value as string)}
    >
      {TIMEZONES.map((tz) => (
        <MenuItem key={tz.value} value={tz.value}>
          {tz.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default TimezoneSelector;
